'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        searchIcon: _search2.default,
        clearIcon: _clear2.default,
        searchIconWidth: palette.gutter * 3 + 'px',
        searchIconHeight: palette.gutter * 3 + 'px',
        clearIconHeight: palette.gutter * 3 + 'px',
        clearIconWidth: palette.gutter * 3 + 'px'
    };
};

var _search = require('../img/search.svg');

var _search2 = _interopRequireDefault(_search);

var _clear = require('../img/clear.svg');

var _clear2 = _interopRequireDefault(_clear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }